import { Unit } from '../models/Unit';
import { resolveUnitBaseColor, UnitBaseColor } from './StudentDashboardAux/getColorByUnit';

/**
 * Per-unit color theme for the "MY NEW FOCUS" modal's backdrop panel, grid overlay, and inner-card
 * border. Driven by the app-wide unit color (`resolveUnitBaseColor(unit.name)`) so the modal matches
 * the hue that unit shows across the dashboard, using softer, modal-tuned shades of the same ramp.
 *
 * Isolated modal design: Figma node 2359-30127
 * https://www.figma.com/design/Ba8KxMAuaE6VAacW8LpO38/%F0%9F%8E%93-Student---Low-fi-Designs?node-id=2359-30127
 */
export interface FocusUnitTheme {
  /** Tailwind bg class for the colored backdrop panel. */
  panel: string;
  /** Tailwind border-color class for the cream inner card. */
  card: string;
  /** Tailwind text-color class — supplies `currentColor` for the CSS grid backdrop. */
  grid: string;
}

// Keyed by the app-wide unit base color; class strings are complete literals so Tailwind's JIT keeps them.
export const FOCUS_UNIT_THEMES: Record<UnitBaseColor, FocusUnitTheme> = {
  sky: { panel: 'tw-bg-sky-300', card: 'tw-border-sky-400', grid: 'tw-text-sky-200' },
  lime: { panel: 'tw-bg-lime-300', card: 'tw-border-lime-400', grid: 'tw-text-lime-200' },
  orange: { panel: 'tw-bg-orange-300', card: 'tw-border-orange-400', grid: 'tw-text-orange-200' },
  purple: { panel: 'tw-bg-purple-300', card: 'tw-border-purple-400', grid: 'tw-text-purple-200' },
  pink: { panel: 'tw-bg-pink-300', card: 'tw-border-pink-400', grid: 'tw-text-pink-200' },
};

/** Resolve the modal theme classes for a focused unit, matching its dashboard color. */
export const getFocusUnitTheme = (unit: Unit | null | undefined): FocusUnitTheme =>
  FOCUS_UNIT_THEMES[resolveUnitBaseColor(unit?.name)];
